module.exports = __webpack_public_path__ + "img/incomeOrange.e006c575.png";